/**
 * store
 */

import { createStore } from "vuex";
import user from "./modules/user";
import post from "./modules/post";
import mobile from "./modules/mobile";

export default createStore({
    modules: {
        user,
        post,
        mobile,
    },
});
